import { css } from 'styled-components';

const opacityDisabled = css `
  opacity: ${({ theme }) => theme.olist.opacity.base};
  cursor: not-allowed;
`;

export { opacityDisabled };
